module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-03.1061bb38.jpg";